import React from "react";
import { Link } from "react-router-dom";

const links = [
  { to: "/about", label: "About Us" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-service", label: "Terms of Service" },
  { to: "/contact", label: "Contact Us" },
];

export const Footer = () => (
  <footer className="mt-12 border-t border-zinc-800/70 py-8 text-center" data-testid="site-footer">
    <div className="text-xs text-zinc-600 mb-3">
      🎬 ABSOLUTE CINEMA · New movie daily at 12:00 AM IST
    </div>
    <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs sm:text-sm">
      {links.map((l, i) => (
        <React.Fragment key={l.to}>
          <Link
            to={l.to}
            className="text-zinc-400 hover:ac-gold-text transition-colors"
            data-testid={`footer-link-${l.to.replace("/", "")}`}
          >
            {l.label}
          </Link>
          {i < links.length - 1 && <span className="text-zinc-700">|</span>}
        </React.Fragment>
      ))}
    </nav>
    <div className="text-[11px] text-zinc-600 mt-4">
      © 2026 Absolute Cinema. All rights reserved.
    </div>
  </footer>
);
